import { cs, FauxLoggedInBar, useTypedTranslation } from "@repo/ui";
import { type FC } from "react";
import Attention from "../../components/AttentionBlock";
import ErrorContent from "../../components/ErrorPage/ErrorContent";
import { PhoneLink } from "../../components/Link/ContactLink";
import { Seo } from "../../components/SEO";

export const AppBar: FC = () => <FauxLoggedInBar />;

const PidError: FC = () => {
    const { t } = useTypedTranslation();

    return (
        <ErrorContent>
            <Attention severity="success" title={cs.pidError.header}>
                <p>{cs.pidError.oneMoreStep}</p>
                <p>{cs.pidError.accountOwnerConfirmation}</p>
                <p>
                    <b>{cs.pidError.contactUs}</b>{" "}
                    <PhoneLink phone={t("appBar.contact.phoneLink")}>{t("appBar.contact.phone")}</PhoneLink>.
                </p>
                <p>{cs.pidError.availability}</p>
            </Attention>
        </ErrorContent>
    );
};

export default PidError;

export const Head: FC = () => (
    <Seo title="Uživatel nenalezen">
        <meta name="robots" content="noindex" />
    </Seo>
);
